import { Box, Button, Typography } from '@material-ui/core'
import axios from 'axios'
import get from 'lodash/get'
import { useState } from 'react'
import { LinearProgress, ReferenceField, TextField, Toolbar, useNotify } from 'react-admin'
import { Form } from 'react-final-form'

import { captureExceptionIfProduction } from 'helpers/utils'
import { JSONField } from '../Fields'
import { scenarioFields, scenarioInitialValues } from './ScenarioFields'

const QAEditView = (props: any) => {
  const notify = useNotify()
  const { id } = props
  const [response, setResponse] = useState(null)
  const [isSubmitted, setIsSubmitted] = useState<any>(null)

  const submit = (values: any) => {
    setResponse(null)
    setIsSubmitted(true)
    axios
      .post(`/api/v1/console/qa/${id}/generate/`, values)
      .then((response: any) => {
        setResponse(response)
      })
      .catch((error) => {
        notify(`${error.message}. ${error.response?.data}`, { type: 'warning' })
        captureExceptionIfProduction(error)
      })
  }

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        {id}
      </Typography>
      <Form
        initialValues={get(scenarioInitialValues, id)}
        onSubmit={submit}
        render={(formProps) => {
          return (
            <form onSubmit={formProps.handleSubmit}>
              {scenarioFields[id]}
              <Toolbar>
                <Box display="flex" justifyContent="space-between" width="100%">
                  <Button variant="contained" color="primary" type="submit">
                    Submit
                  </Button>
                </Box>
              </Toolbar>
            </form>
          )
        }}
      />
      <Box>{isSubmitted && !response && <LinearProgress />}</Box>
      <Box p={4}>
        {response && (
          <Typography variant="h6" gutterBottom>
            Generated Models
          </Typography>
        )}
        {response && <Typography variant="caption">Open in a new tab to retain output.</Typography>}
        {get(response, 'data.references', []).map((reference, index) => (
          <div key={index}>
            <Typography variant="h6"> {reference['resource']}: </Typography>
            <ReferenceField
              {...props}
              record={reference}
              source="id"
              reference={reference['resource']}
              link="show"
            >
              <TextField record={reference} source="id" />
            </ReferenceField>
          </div>
        ))}
      </Box>
      <Box p={4}>
        {response && (
          <Typography variant="h6" gutterBottom>
            Full Response
          </Typography>
        )}
        <JSONField record={get(response, 'data')} source="response" />
      </Box>
    </div>
  )
}

const QAEdit = (props: any) => {
  return <QAEditView {...props} />
}

export default QAEdit
